import { Toast } from 'primereact/toast'

export const onQuerySuccess = (toast: React.RefObject<Toast>, msg?: string) => {
  toast.current?.clear()
  toast.current?.show({
    severity: 'success',
    summary: 'Success',
    detail: msg || 'Action successful',
    life: 3000,
  })
}

export const onQueryError = (toast: React.RefObject<Toast>, msg?: string) => {
  toast.current?.clear()
  toast.current?.show({
    severity: 'error',
    summary: 'Error',
    detail: msg || 'Action failed',
    life: 3000,
  })
}
